module.exports = __webpack_public_path__ + "static/media/technology-cover-Mobile.d5c024ce.png";